<template>
  <v-app id="vue-app">
    <premium-suspended></premium-suspended>
    <alert-banners></alert-banners>
    <router-view name="navigation"></router-view>
    <v-main>
      <login-window-modal></login-window-modal>
      <on-boarding-welcome-modal v-if="uiModalsStore.displayOnBoardingWelcomeModal"></on-boarding-welcome-modal>
      <app-msg-boxes></app-msg-boxes>
      <navigation-fullscreen></navigation-fullscreen>
      <zoho-chat></zoho-chat>
      <v-container id="vue-main-container" fluid style="min-height: calc(100vh - var(--v-layout-top))">
        <router-view :key="$route.path"></router-view>
      </v-container>

      <!-- TOASTS -->
      <v-snackbar-queue v-model="uiDashboardsStore.toasts" :max-width="560" close-on-content-click>
        <template #text="{ item }">
          <v-badge v-if="uiDashboardsStore.toasts.length" color="#00000077" :content="uiDashboardsStore.toasts.length + 1" style="position: absolute; top: 8px; right: 8px;"></v-badge>
          <div class="flex-center-center pre"><v-icon v-if="item.icon" start>{{ item.icon }}</v-icon>{{ item.text }}</div>
        </template>
      </v-snackbar-queue>
    </v-main>
  </v-app>
</template>

<style>
  .mobileview #vue-main-container {
    padding: 0 !important;
  }
</style>

<script>
  import { defineAsyncComponent } from 'vue';
  import { mapActions } from 'pinia';
  import useUsersStore from '@/stores/users';
  import useUsersAccessRightStore from '@/stores/users/accessRight';
  import useUserOptionsStore from '@/stores/user-options';
  import useUiModalsStore from '@/stores/ui/modals';
  import useUiDashboardsStore from '@/stores/ui/dashboards';
  import clientConfig from '@/client_customs/config';
  import AlertBanners from '@/components/AlertBanners/AlertBanners.vue';
  import LoginWindowModal from '@/components/User/LoginWindowModal.vue';
  import PremiumSuspended from '@/components/Premium/PremiumSuspended.vue';
  import AppMsgBoxes from '@/components/MsgBox/AppMsgBoxes.vue';
  import NavigationFullscreen from '@/components/Navigation/NavigationFullscreen.vue';
  import ZohoChat from '@/components/Help/ZohoChat.vue';

  export default {
    components: {
      AlertBanners,
      LoginWindowModal,
      OnBoardingWelcomeModal: defineAsyncComponent(() => import('@/components/OnBoarding/OnBoardingWelcomeModal.vue')),
      PremiumSuspended,
      AppMsgBoxes,
      NavigationFullscreen,
      ZohoChat,
    },
    data() {
      return {
        usersStore: useUsersStore(),
        accessRightStore: useUsersAccessRightStore(),
        uiModalsStore: useUiModalsStore(),
        uiDashboardsStore: useUiDashboardsStore(),
      };
    },
    created() {
      if (clientConfig.startupScript) clientConfig.startupScript();

      this.usersStore.userPromise.then((user) => {
        if (this.uiModalsStore.displayOnBoardingWelcomeModal) return;
        // new version popup
        if (user.last_visit && moment(user.last_visit).isBefore('2026-07-06') && moment().isBefore('2026-08-31')) {
          this.uiModalsStore.setDisplayNewVersionsWindow(true);
        }

        // apply appearance settings
        const computedConfig = this.accessRightStore.config;
        if (computedConfig.themePalette) document.body.classList.add(`colors-${computedConfig.themePalette}`);
      });

      // apply appearance settings
      this.loadUserOptions({ filter: 'appearance' }).then(({ 'appearance-theme': theme, 'appearance-theme-bg': themeBg }) => {
        this.$vuetify.theme.change(theme || 'light');
        if (themeBg) document.body.classList.add(`custom-bg-${themeBg}`);
      }).catch((error) => { this.usersStore.userPromise.then(() => { throw error; }); /* catch error for anonymous */ });
    },
    methods: {
      ...mapActions(useUserOptionsStore, ['loadUserOptions']),
    },
  };
</script>
